import { HistoryPageStatePresenter } from '@/presentation/presenters/history/historyPageStatePresenter'
import { HistoryPageStateViewModel } from '@/presentation/viewmodels/history/historyPageStateViewModel'

export function useHistoryPageStatePresenter(
  presenter: HistoryPageStatePresenter = new HistoryPageStatePresenter(new HistoryPageStateViewModel())
) {
  return {
    historyExpandedList: presenter.historyExpandedList,
    historyLoadingList: presenter.historyLoadingList,
    pageIndex: presenter.pageIndex,
    isFirstOpendPage: presenter.isFirstOpendPage,
    isNotMoreHistoryList: presenter.isNotMoreHistoryList,
    hasDataInExpandedList: presenter.hasDataInExpandedList.bind(presenter),
    hasDataInLoadingList: presenter.hasDataInLoadingList.bind(presenter),
    setPageIndex: presenter.setPageIndex.bind(presenter),
    setIsFirstOpendPage: presenter.setIsFirstOpendPage.bind(presenter)
  }
}
